import React, { useEffect, useRef, useState } from "react";
import Activity, { getActivityAvalability } from "../../models/Activity";
import { getLocalActivities, getLocalActivitiesByCategories, getLocalCategories, getLocalSections } from "../../../specific/utils/LocalStorage";
import * as Navigation from "../../../specific/utils/Navigation/Navigation";
import { ActivityIndicator, Image, Platform, ScrollView, StyleSheet, TouchableOpacity } from "react-native";
import View from "../../components/ReactNative/View";
import AppTheme from "../../utils/Theme";
import ActivityHeaderImage from "../../components/Activities/ActivityHeaderImage";
import ActivityCellTitle from "../../components/Activities/ActivityCells/ActivityCellTitle";
import ActivityCellBody from "../../components/Activities/ActivityCells/ActivityCellBody";
import Text from "../../components/ReactNative/Text";
import { Bloc, getStringFromMatrixLocalizedString, MatrixLocalizedString } from "../rooms/FamilyRoom";
import Fonts from "../../Theme/Fonts";
import { getLanguage } from "../../utils/Localization/Localization";
import ActionButton from "../../components/Actions/ActionButton";
import Category from "../../models/Category";
import Images from "../../../specific/utils/Images";
import SVGIconButton from "../../designSystem/Buttons/SVGIconButton";
import { IcClose, IcLightBulb, IcLiliStar } from "../../utils/Icons";
import Modal from "../../../specific/components/Modal/Modal";
import Colors from "../../Theme/Colors";
import { getImageSource } from "../../utils/Images/ImagesUtils";
import { analyticsEventPaywallDisplayed, propertiesEventCategory, propertiesEventProfile, propertiesEventSource, trackEvent } from "../../services/Tracking/Analytics";
import NavBarButton from "../../components/NavBar/NavBarButton";
import { ScreenActivityMediaList, ScreenActivityMediaSheet, ScreenActivityPlaylist, ScreenActivitySheet, ScreenActivitySheetScreen, ScreenCategoryHome, ScreenSectionCategories, ScreenSubscriptionPaywall } from "../../utils/Constants";
import Divider from "../../designSystem/Divider/Divider";
import User from "../../data/user/User";
import { useSpecificSize } from "../../../specific/Theme/SpecificSize";
import Style from "../../utils/Style";
import Alert from "../../components/Notification/Alert";
import InViewModal from "../../../specific/components/InViewModal/InViewModal";
import SVGView from "../../utils/SvgView";

export type DetailsData = {
    title?: MatrixLocalizedString;
    subtitle: MatrixLocalizedString;
    img_source: { uri: string } | number;
    details: MatrixLocalizedString;
}

export type ActivityAction = {
    key: string;
    title: MatrixLocalizedString;
    type: "audio" | "doc" | "pdf" | "video";
    url?: MatrixLocalizedString;
    doc_id?: MatrixLocalizedString;
}

interface ActivitySheetScreenProps {
    referrerTitle?: string;
    activityId: string;
    componentId: string;
    isModal?: boolean;
}

const ActivitySheetScreen = (props: ActivitySheetScreenProps) => {

    const appTheme: AppTheme = new AppTheme();
    const user: User = User.getInstance();
    const images: Images = new Images();

    const [localActivities, setLocalActivities] = useState(undefined);
    const [localActivitiesByCategory, setLocalActivitiesByCategory] = useState(undefined);
    const [localCategories, setLocalCategories] = useState(undefined);
    const [localSections, setLocalSections] = useState(undefined);
    const [activity, setActivity] = useState<Activity | undefined>(undefined);

    // Details display
    const [detailsData, setDetailsData] = useState<DetailsData | undefined>(undefined);

    const alertRef = useRef<Alert>(null);
    const inViewModal = useRef<InViewModal>(null);
    const viewRef = useRef<ScrollView>(null);

    let propsData = props;
    let navigate = null;
    if (Platform.OS === "web") {
        //propsData = Navigation.useParams();
        navigate = Navigation.useNavigate();
    }

    const { activityId, componentId, referrerTitle = "", isModal = false } = propsData;

    const {
        fullScreenWidth,
        fullScreenHeight,
        availableScreenSize,
        contentSize,
        sideMenuSize,
        horizontalSpacing
    } = useSpecificSize();

    useEffect(() => {
        if (Platform.OS === "web") {
            window.scrollTo(0, 0);
        }
    }, []);

    useEffect(() => {
        if (activity === undefined) {
            getActivityFromLocalData();
        }
    }, [activity]);

    useEffect(() => {
        if (localSections === undefined) {
            getSectionsFromLocalData();
        }
    }, [localSections]);

    useEffect(() => {
        if (localCategories === undefined) {
            getCategoriesFromLocalData();
        }
    }, [localCategories]);

    useEffect(() => {
        if (localActivitiesByCategory === undefined) {
            getActivitiesByCategoryFromLocalData();
        }
    }, [localActivitiesByCategory]);

    useEffect(() => {
        if (localActivities !== undefined) {
            if (localActivities[activityId] !== undefined) {
                setActivity(localActivities[activityId]);
                if ((activity?.categoryKeys !== undefined) && (activity.categoryKeys[0] !== undefined)) {
                    if ((localCategories !== undefined) && (localCategories[activity.categoryKeys[0]] !== undefined)) {
                        const category: Category = localCategories[activity.categoryKeys[0]];
                        trackEvent("activity_viewed", {
                            [propertiesEventCategory]: category.analytics_key,
                            content: activity?.action.type,
                            access: activity?.isPremium() === true ? "premium" : "free",
                            activity_name: activity?.analytics_key,
                            starting_point: "neuroscience"
                        });
                    }
                }

            } else {
                onCloseRequest();
            }
        }
    }, [localActivities]);

    const onCloseRequest = () => {
        if (Platform.OS === "web") {
            Navigation.dismissModalInView({ componentId, navigate });
        } else {
            console.log({isModal})
            if (isModal === true) {
                Navigation.dismissModal({ componentId, navigate });
            } else {
                Navigation.pop({ componentId, navigate });
            }
        }
    }

    const getActivityFromLocalData = async () => {
        const localActivitiesFromStorage = await getLocalActivities();
        setLocalActivities(localActivitiesFromStorage.data);
    }

    const getCategoriesFromLocalData = async () => {
        const localCategoriesFromStorage = await getLocalCategories();
        setLocalCategories(localCategoriesFromStorage.data);
    }

    const getActivitiesByCategoryFromLocalData = async () => {
        const localActivitiesByCategoriesFromStorage = await getLocalActivitiesByCategories();
        setLocalActivitiesByCategory(localActivitiesByCategoriesFromStorage.data);
    }

    const getSectionsFromLocalData = async () => {
        const localSectionsFromStorage = await getLocalSections();
        setLocalSections(localSectionsFromStorage.data);
    }

    const renderActions = (actions: ActivityAction[]): React.JSX.Element | null => {
        if ((actions !== undefined) && (actions !== null)) {
            let actionsView: React.JSX.Element[] = [];
            for (const anAction of actions) {
                actionsView.push(<ActionButton activity={activity} action={anAction} />)
            }
            if (actionsView.length > 0) {
                return <View style={{ marginTop: appTheme.pixelPerfect(10), flexDirection: "row", gap: appTheme.pixelPerfect(10), paddingHorizontal: appTheme.pixelPerfect(10), justifyContent: "center" }}>
                    {actionsView}
                </View>;
            }

        }
        return null;
    }

    const showCategory = (aCategory: Category) => {
        if (Platform.OS === "web") {
            Navigation.showModalInView({
                componentId,
                navigate,
                name: ScreenCategoryHome,
                passProps: {
                    categoryKey: aCategory.key,
                    section: "room",
                    origin: "neuroscience"
                }
            })
        } else {
            Navigation.push({
                name: ScreenCategoryHome,
                componentId,
                navigate,
                passProps: {
                    categoryKey: aCategory.key,
                    section: "room",
                    origin: "neuroscience"
                }
            })
        }

    }

    const showSubscription = () => {
        if ((user.demo !== undefined) && (user.demo === true)) {
            let title = "Compte de démonstration";
            let body = "Pour accéder aux ateliers Premium, il vous faut un abonnement. Vous pouvez en faire la demande sur le site tne.reseau-canope.fr";
            alertRef.current?.showAlert({
                title,
                body
            });
        } else {
            Navigation.showModalInView({
                componentId: componentId,
                name: ScreenSubscriptionPaywall,
                passProps: {
                    isModal: true
                }
            })
        }
    }

    const showActivity = (data: { anActivity: Activity, mediaPlaylist?: boolean, aCategory?: Category, aParentActivityTitle?: string }) => {
        const { anActivity, mediaPlaylist, aCategory, aParentActivityTitle } = data;
        let isActivityAvailable = getActivityAvalability(anActivity);
        if (isActivityAvailable === false) {
            trackEvent(analyticsEventPaywallDisplayed, { [propertiesEventSource]: "activity_sheet_screen", [propertiesEventProfile]: user.userProfile() })
            showSubscription();
        } else {
            if ((anActivity.is_child !== undefined) && (anActivity.is_child === true)) {
                if (Platform.OS === "web") {
                    Navigation.showModalInView({
                        componentId,
                        navigate,
                        name: ScreenActivitySheetScreen,
                        passProps: {
                            activityId: anActivity.key,
                            referrerTitle: aParentActivityTitle !== undefined ? aParentActivityTitle : aCategory.title[getLanguage()]
                        }
                    })
                } else {
                    Navigation.push({
                        componentId,
                        navigate,
                        name: ScreenActivitySheetScreen,
                        passProps: {
                            activityId: anActivity.key,
                            referrerTitle: aParentActivityTitle !== undefined ? aParentActivityTitle : aCategory.title[getLanguage()]
                        }
                    });
                }
            } else if ((anActivity.is_playlist !== undefined) && (anActivity.is_playlist === true)) {
                if (Platform.OS === "web") {
                    Navigation.showModalInView({
                        componentId,
                        navigate,
                        name: ScreenActivityPlaylist,
                        passProps: {
                            activityId: anActivity.key
                        }
                    })
                } else {
                    Navigation.push({
                        componentId,
                        navigate,
                        name: ScreenActivityPlaylist,
                        passProps: {
                            activityId: anActivity.key
                        }
                    })
                }
            } else if ((mediaPlaylist !== undefined) && (mediaPlaylist === true)) {
                if (Platform.OS === "web") {
                    Navigation.showModalInView({
                        componentId,
                        navigate,
                        name: ScreenActivityMediaList,
                        passProps: {
                            activity: anActivity,
                            category: aCategory
                        }
                    })
                } else {
                    Navigation.push({
                        componentId,
                        navigate,
                        name: ScreenActivityMediaList,
                        passProps: {
                            activity: anActivity,
                            category: aCategory
                        }
                    });
                }

            } else {
                if (Platform.OS === "web") {
                    Navigation.showModalInView({
                        componentId,
                        navigate,
                        name: ScreenActivitySheet,
                        passProps: {
                            activityKey: anActivity.key,
                            ategoryKey: anActivity.category_keys[0],
                            sectionKey: anActivity.section_key
                        }
                    })
                } else {
                    Navigation.push({
                        name: ScreenActivitySheet,
                        componentId,
                        navigate,
                        passProps: {
                            activityKey: anActivity.key,
                            categoryKey: anActivity.category_keys[0],
                            sectionKey: anActivity.section_key
                        }
                    })
                }
            }
        }
    }

    const showMedia = (anActivity: Activity, aMedia: any) => {
        let aSubActivityCategory: Category | undefined = undefined;
        if ((localCategories !== undefined) && (anActivity?.category_keys !== undefined) && (anActivity.category_keys.length > 0)) {
            aSubActivityCategory = localCategories[anActivity.category_keys[0]];
        }
        if (Platform.OS === "web") {
            Navigation.showModalInView({
                componentId,
                navigate,
                name: ScreenActivityMediaSheet,
                passProps: {
                    activity: anActivity,
                    media: aMedia,
                    category: aSubActivityCategory
                }
            })
        } else {
            Navigation.push({
                name: ScreenActivityMediaSheet,
                componentId,
                navigate,
                passProps: {
                    activity: anActivity,
                    media: aMedia,
                    category: aSubActivityCategory
                }
            })
        }

    }

    const showSection = (aSection: any) => {
        if (Platform.OS === "web") {
            Navigation.showModalInView({
                componentId,
                navigate,
                name: ScreenSectionCategories,
                passProps: {
                    sectionKey: aSection.key
                }
            })
        } else {
            Navigation.push({
                name: ScreenSectionCategories,
                componentId,
                navigate,
                passProps: {
                    sectionKey: aSection.key
                }
            })
        }
    }

    const renderContent = (blocs?: Bloc[]): React.JSX.Element[] | null => {
        if (blocs !== undefined) {
            let aContentView: React.JSX.Element[] = [];
            for (const aBloc of blocs) {
                if (aBloc.type === "custom") {
                    aContentView?.push(<View style={{ width: contentSize, padding: appTheme.pixelPerfect(10), backgroundColor: appTheme.darkBlue, alignItems: "center" }}>
                        <Text style={{ fontSize: appTheme.pixelPerfectForFont(8), fontFamily: Fonts.primary.bold, color: "#FFFFFF" }}>{getStringFromMatrixLocalizedString(aBloc.title)?.toLocaleUpperCase()}</Text>
                    </View>);
                    let aBlocContent: React.JSX.Element[] | null = aBloc.content !== undefined ? renderContent(aBloc.content) : null;
                    if (aBlocContent !== null) {
                        aContentView.push(aBlocContent);
                    }
                } else if (aBloc.type === "activity") {
                    const aSubActivity: Activity | undefined = localActivities[aBloc.key];
                    if (aSubActivity !== undefined) {
                        let aParentActivity: Activity | undefined = undefined;
                        let aParentActivityTitle: string | undefined = undefined;
                        if (aSubActivity.is_child === true) {
                            // On va chercher son parent en récupérant le code de l'activité
                            let parentActivityKey: string = aSubActivity.key.substring(0, 6);
                            if (localActivities[parentActivityKey] !== undefined) {
                                aParentActivity = localActivities[parentActivityKey];
                            }
                            aParentActivityTitle = aParentActivity.title[getLanguage()];
                            if ((aParentActivity[user.profile] !== undefined) && (aParentActivity[user.profile].title !== undefined) && (aParentActivity[user.profile].title[getLanguage()] !== undefined)) {
                                aParentActivityTitle = aParentActivity[user.profile].title[getLanguage()];
                            }
                        }
                        let aSubActivityCategory: Category | undefined = undefined;
                        let categoryTitle: string = "";
                        let mediaPlaylistType: boolean = false;
                        let aCategoryKey: string | undefined = undefined;
                        if ((localCategories !== undefined) && (aSubActivity?.category_keys !== undefined) && (aSubActivity.category_keys.length > 0)) {
                            aCategoryKey = aSubActivity.category_keys[0];
                            aSubActivityCategory = localCategories[aCategoryKey];
                            if ((aCategoryKey === "cps") || (aCategoryKey === "wellBeing") || (aCategoryKey === "phi_questions")) {
                                mediaPlaylistType = true;
                            }
                            categoryTitle = aSubActivityCategory.title[getLanguage()];
                            if ((aSubActivityCategory[user.profile] !== undefined) && (aSubActivityCategory[user.profile].title !== undefined) && (aSubActivityCategory[user.profile].title[getLanguage()] !== undefined)) {
                                categoryTitle = aSubActivityCategory[user.profile].title[getLanguage()];
                            }
                        }
                        let aCategoryTitleView: React.JSX.Element | null = null;
                        if (aParentActivityTitle !== undefined) {
                            aCategoryTitleView = <Text style={[styles.category_title, { fontSize: appTheme.pixelPerfectForFont(7) }]}>{aParentActivityTitle}</Text>
                        } else if (aSubActivityCategory !== undefined) {
                            aCategoryTitleView = <Text style={[styles.category_title, { fontSize: appTheme.pixelPerfectForFont(7) }]}>{categoryTitle}</Text>
                        }
                        let aDetailsButton: React.JSX.Element | null = null;
                        if (aBloc.body !== undefined) {
                            aDetailsButton = <SVGIconButton onPress={() => setDetailsData({
                                title: { default: aSubActivity.title },
                                subtitle: { default: { [getLanguage()]: categoryTitle } },
                                img_source: getImageSource({ app_image: aSubActivity.app_image, img_url: aSubActivity.img_url }),
                                details: aBloc.body
                            })} Icon={IcLightBulb} backgroundColor={appTheme.darkBlue} color={appTheme.white} />;
                        }
                        let isActivityAvailable = getActivityAvalability(aSubActivity);
                        const premiumMark = isActivityAvailable === false ? <View style={[Style.shadowed, { width: appTheme.pixelPerfect(16), height: appTheme.pixelPerfect(16), borderRadius: appTheme.pixelPerfect(8), backgroundColor: appTheme.premium, position: "absolute", top: appTheme.pixelPerfect(2), right: appTheme.pixelPerfect(2), justifyContent: 'center', alignItems: 'center' }]}>
                            <SVGView Component={IcLiliStar} size={appTheme.pixelPerfect(10)} color={appTheme.white} />
                        </View> : null;
                        aContentView.push(<TouchableOpacity onPress={() => showActivity({ anActivity: aSubActivity, mediaPlaylist: mediaPlaylistType, aCategory: aSubActivityCategory, aParentActivityTitle })} style={[styles.content_cell, { padding: appTheme.pixelPerfect(10) }]}>
                            <View>
                                <Image source={getImageSource({ app_image: aSubActivity.app_image, img_url: aSubActivity.img_url })} style={{ width: appTheme.pixelPerfect(50), height: appTheme.pixelPerfect(50), borderRadius: appTheme.pixelPerfect(10) }} />
                                {premiumMark}
                            </View>
                            <View style={{ flex: 1 }}>
                                <Text style={[styles.activity_title, { fontSize: appTheme.pixelPerfectForFont(7) }]}>{aSubActivity.title[getLanguage()]}</Text>
                                {aCategoryTitleView}
                            </View>
                            {aDetailsButton}
                        </TouchableOpacity>);
                    }
                } else if (aBloc.type === "category") {
                    if (localCategories !== undefined) {
                        const aSubCategory: Category | undefined = localCategories[aBloc.key];
                        //On va essayer de récupérer la première activité de la catégorie pour récupérer son image
                        let imageSource: number | { uri: string } = getImageSource({ app_image: aSubCategory.app_image, img_url: aSubCategory.img_url });
                        if ((localActivitiesByCategory !== undefined) && (localActivitiesByCategory[aBloc.key] !== undefined)) {
                            for (const anActivityKey of localActivitiesByCategory[aBloc.key]) {
                                if ((localActivities !== undefined) && (localActivities[anActivityKey] !== undefined)) {
                                    const anActivity: Activity = localActivities[anActivityKey];
                                    if (anActivity.status === "published") {
                                        imageSource = getImageSource({ app_image: anActivity.app_image, img_url: anActivity.img_url });
                                        break;
                                    }
                                }
                            }
                        }
                        if (aSubCategory !== undefined) {
                            let categoryTitle: string = aSubCategory.title[getLanguage()];
                            if ((aSubCategory[user.profile] !== undefined) && (aSubCategory[user.profile].title !== undefined) && (aSubCategory[user.profile].title[getLanguage()] !== undefined)) {
                                categoryTitle = aSubCategory[user.profile].title[getLanguage()];
                            }
                            let aDetailsButton: React.JSX.Element | null = null;
                            if (aBloc.body !== undefined) {
                                aDetailsButton = <SVGIconButton onPress={() => setDetailsData({
                                    title: { default: { [getLanguage()]: categoryTitle } },
                                    details: aBloc.body,
                                    img_source: imageSource
                                })} Icon={IcLightBulb} backgroundColor={appTheme.darkBlue} color={appTheme.white} />;
                            }
                            aContentView.push(<TouchableOpacity onPress={() => showCategory(aSubCategory)} style={[styles.content_cell, { padding: appTheme.pixelPerfect(10) }]}>
                                <Image source={imageSource} style={{ width: appTheme.pixelPerfect(50), height: appTheme.pixelPerfect(50), borderRadius: appTheme.pixelPerfect(10) }} />
                                <View style={{ flex: 1 }}>
                                    <Text style={[styles.category_title, { fontSize: appTheme.pixelPerfectForFont(7) }]}>{categoryTitle}</Text>
                                </View>
                                {aDetailsButton}
                            </TouchableOpacity>);
                        }
                    }

                } else if (aBloc.type === "section") {
                    if (localSections !== undefined) {
                        const aSubSection = localSections[aBloc.key];
                        console.log({ aSubSection });
                        if (aSubSection !== undefined) {
                            let bgColor: string = ((aSubSection.colors !== undefined) && (aSubSection.colors.bg !== undefined)) ? aSubSection.colors.bg : Colors.darkBlue;
                            let txtColor: string = ((aSubSection.colors !== undefined) && (aSubSection.colors.txt !== undefined)) ? aSubSection.colors.txt : "#FFFFFF";
                            console.log({ txtColor })
                            let inAppImage: string | undefined = getStringFromMatrixLocalizedString(aSubSection.app_image);
                            let aDetailsButton: React.JSX.Element | null = <View style={{ height: appTheme.pixelPerfect(60), width: appTheme.pixelPerfect(60) }} />;
                            if (aBloc.body !== undefined) {
                                aDetailsButton = <SVGIconButton onPress={() => setDetailsData({
                                    title: aSubSection.title,
                                    img_source: images[getStringFromMatrixLocalizedString(aSubSection.app_header)],
                                    details: aBloc.body
                                })} Icon={IcLightBulb} backgroundColor={appTheme.darkBlue} color={appTheme.white} />;
                            }
                            aContentView.push(<TouchableOpacity onPress={() => showSection(aSubSection)} style={[styles.content_cell, { padding: appTheme.pixelPerfect(10) }]}>
                                <View style={{ flex: 1, padding: appTheme.pixelPerfect(4), borderRadius: appTheme.pixelPerfect(10), backgroundColor: bgColor, flexDirection: "row", alignItems: "center" }}>
                                    <Image source={getImageSource({ app_image: inAppImage, img_url: aSubSection.img_url })} style={{ width: appTheme.pixelPerfect(50), height: appTheme.pixelPerfect(50), borderRadius: appTheme.pixelPerfect(10) }} />
                                    <Text style={[styles.section_title, { color: txtColor, flex: 1, textAlign: "center", fontSize: appTheme.pixelPerfectForFont(7) }]}>{getStringFromMatrixLocalizedString(aSubSection.title)}</Text>
                                </View>
                                {aDetailsButton}
                            </TouchableOpacity>);
                        }
                    }
                } else if (aBloc.type === "media") {
                    // On va devoir retrouver l'activité liée à ce média
                    if (localActivities !== undefined) {
                        let mediaActivity: Activity | undefined = undefined;
                        let mediaToShow = undefined;
                        for (const anActivityKey in localActivities) {
                            if (!Object.hasOwn(localActivities, anActivityKey)) continue;

                            const anActivity: Activity = localActivities[anActivityKey];
                            if (anActivity.media !== undefined) {
                                for (const aMedia of anActivity.media) {
                                    if (aMedia.id === aBloc.key) {
                                        // On a trouvé le média
                                        mediaToShow = aMedia;
                                        mediaActivity = anActivity;
                                        break;
                                    }
                                }
                            }
                            if (mediaActivity !== undefined) {
                                break;
                            }
                        }
                        if (mediaActivity !== undefined) {
                            let aDetailsButton: React.JSX.Element | null = null;
                            if (aBloc.body !== undefined) {
                                aDetailsButton = <SVGIconButton onPress={() => setDetailsData({
                                    title: { default: mediaToShow.title },
                                    subtitle: { default: mediaActivity.title },
                                    img_source: getImageSource({ app_image: mediaActivity.app_image, img_url: mediaActivity.img_url }),
                                    details: aBloc.body
                                })} Icon={IcLightBulb} backgroundColor={appTheme.darkBlue} color={appTheme.white} />;
                            }
                            aContentView.push(<TouchableOpacity onPress={() => showMedia(mediaActivity, mediaToShow)} style={[styles.content_cell, { padding: appTheme.pixelPerfect(10) }]}>
                                <Image source={getImageSource({ app_image: mediaActivity.app_image, img_url: mediaActivity.img_url })} style={{ width: appTheme.pixelPerfect(50), height: appTheme.pixelPerfect(50), borderRadius: appTheme.pixelPerfect(10) }} />
                                <View style={{ flex: 1 }}>
                                    <Text style={[styles.activity_title, { fontSize: appTheme.pixelPerfectForFont(7) }]}>{mediaToShow.title[getLanguage()]}</Text>
                                    <Text style={[styles.category_title, { fontSize: appTheme.pixelPerfectForFont(7) }]}>{mediaActivity.title[getLanguage()]}</Text>
                                </View>
                                {aDetailsButton}
                            </TouchableOpacity>);
                        }
                    }
                }
            }
            return aContentView;
        }
        return null;
    }

    const renderDetailsDataModal = (): React.JSX.Element | null => {
        if (detailsData !== undefined) {
            const { img_source, subtitle, details } = detailsData;
            let imageView: React.JSX.Element | null = null;
            let imageHeight: number = contentSize * 1080 / 1440;
            let paddingTop: number = imageHeight * 0.9;
            let resizeMode: "contain" | "cover" = "cover";
            if (Platform.OS === "web") {
                paddingTop = appTheme.pixelPerfect(160);
                imageHeight = paddingTop;
                resizeMode = "contain";
            }
            if (img_source !== undefined) {
                imageView = <Image source={img_source} style={{ position: "absolute", top: 0, width: contentSize, height: imageHeight }} resizeMode={resizeMode} />
            }
            const marginTop: number = Platform.OS === "web" ? appTheme.pixelPerfect(20) : 0;
            const borderRadius: number = Platform.OS === "web" ? appTheme.pixelPerfect(10) : 0;
            if (Platform.OS === "web") {
                return <View style={{ width: fullScreenWidth, alignItems: "center", flex: 1, paddingLeft: sideMenuSize, paddingTop: marginTop, borderRadius }}>
                    <View style={{ backgroundColor: "#FFFFFFCC", width: contentSize, height: fullScreenHeight, position: "absolute", borderRadius }} />
                    <View style={{ width: contentSize, alignItems: "center", borderRadius }}>
                        <View style={{ backgroundColor: "#FFFFFF", paddingTop, width: contentSize, borderRadius }}>
                            {imageView}
                            <View style={{ backgroundColor: "#FFFFFF", flex: 1, borderTopLeftRadius: appTheme.pixelPerfect(20), borderTopRightRadius: appTheme.pixelPerfect(20) }}>
                                <ActivityCellTitle
                                    categoryTitle={detailsData.subtitle !== undefined ? getStringFromMatrixLocalizedString(detailsData.subtitle) : undefined}
                                    title={detailsData.title.default}
                                    color={appTheme.darkBlue}
                                    width={contentSize} />
                                <View style={{ flex: 1 }}>
                                    <Text style={{ fontFamily: Fonts.primary.regular, fontSize: appTheme.pixelPerfectForFont(10), padding: appTheme.pixelPerfect(10) }}>{getStringFromMatrixLocalizedString(details)}</Text>
                                    <View style={{ height: appTheme.pixelPerfect(60), width: contentSize }} />
                                </View>
                            </View>

                            <View style={{ position: "absolute", top: appTheme.topInsets > 0 ? appTheme.topInsets : appTheme.pixelPerfect(10), right: appTheme.pixelPerfect(10) }}>
                                <NavBarButton action={() => setDetailsData(undefined)} icon={IcClose} />
                            </View>
                        </View>
                    </View>
                </View>
            }
            return <View style={{ width: fullScreenWidth, alignItems: "center", flex: 1, paddingLeft: sideMenuSize, paddingTop: marginTop }}>
                <View style={{ width: contentSize, alignItems: "center", height: fullScreenHeight }}>
                    <View style={{ backgroundColor: "#FFFFFF", height: fullScreenHeight, paddingTop, width: contentSize, borderRadius, overflow: "hidden" }}>
                        {imageView}
                        <View style={{ backgroundColor: "#FFFFFF", flex: 1, borderTopLeftRadius: appTheme.pixelPerfect(20), borderTopRightRadius: appTheme.pixelPerfect(20) }}>
                            <ActivityCellTitle
                                categoryTitle={detailsData.subtitle !== undefined ? getStringFromMatrixLocalizedString(detailsData.subtitle) : undefined}
                                title={detailsData.title.default}
                                color={appTheme.darkBlue}
                                width={contentSize} />
                            <ScrollView style={{ flex: 1 }}>
                                <Text style={{ fontFamily: Fonts.primary.regular, fontSize: appTheme.pixelPerfectForFont(10), padding: appTheme.pixelPerfect(10) }}>{getStringFromMatrixLocalizedString(details)}</Text>
                            </ScrollView>
                        </View>
                        <View style={{ position: "absolute", top: appTheme.topInsets > 0 ? appTheme.topInsets : appTheme.pixelPerfect(10), right: appTheme.pixelPerfect(10) }}>
                            <NavBarButton action={() => setDetailsData(undefined)} icon={IcClose} />
                        </View>
                    </View>
                </View>
            </View>
        }
        return null
    }

    const renderActivitySheetContent = () => {
        if (activity === undefined) {
            return <ActivityIndicator color={appTheme.darkBlue} />
        }

        const borderRadius: number = Platform.OS === "web" ? appTheme.pixelPerfect(20) : 0;
        return <View style={[Style.shadowed, { flex: 1, width: contentSize, alignItems: "center", borderRadius, backgroundColor: "#FFFFFF", overflow: "hidden" }]}>
            <ActivityHeaderImage isModal={isModal} activity={activity} onCloseRequest={onCloseRequest} showButton={true} />
            <ScrollView style={{ width: contentSize, flex: 1, backgroundColor: appTheme.white }}>
                <View style={{ flex: 1 }}>
                    <ActivityCellTitle
                        categoryTitle={referrerTitle}
                        title={activity.title}
                        chapo={activity.chapo}
                        duration={activity.duration}
                        color={appTheme.darkBlue}
                        width={contentSize} />
                    {renderActions(activity.actions)}
                    <ActivityCellBody
                        body={activity.body}
                        color={appTheme.darkBlue}
                        width={contentSize} />
                    <Divider size={20} />
                    {renderContent(activity.content)}
                    <View style={{ height: appTheme.pixelPerfect(40) }} />
                </View>
            </ScrollView>
            <Modal visible={detailsData !== undefined} transparent={true} animationType="slide">
                {renderDetailsDataModal()}
            </Modal>
            <Alert ref={alertRef} />
            <InViewModal ref={inViewModal} />
        </View>
    }

    if (Platform.OS === "web") {
        return <ScrollView onLayout={() => {
            if (viewRef.current !== null) {
                viewRef.current.scrollTo({ x: 0, y: 0, animated: true });
            }
        }} ref={viewRef} style={[{ paddingLeft: sideMenuSize, height: fullScreenHeight, width: fullScreenWidth }]}>
            <View style={{ width: availableScreenSize, alignItems: "center", paddingTop: appTheme.pixelPerfect(20), paddingBottom: appTheme.pixelPerfect(40) }}>
                {renderActivitySheetContent()}
            </View>
        </ScrollView>
    }

    return renderActivitySheetContent();
}

export default ActivitySheetScreen;

const styles = StyleSheet.create({
    content_cell: {
        flexDirection: "row",
        gap: 10,
        alignItems: "center",
        flex: 1
    },
    activity_title: {
        fontFamily: Fonts.primary.bold,
        color: Colors.darkBlue
    },
    category_title: {
        fontFamily: Fonts.primary.medium,
        textTransform: "uppercase",
        color: Colors.darkBlue
    },
    section_title: {
        fontFamily: Fonts.superHero.bold,
        textTransform: "uppercase"
    },
    section_subtitle: {

    }
});